import { render, staticRenderFns } from "./Sicon.vue?vue&type=template&id=72c95659&scoped=true&"
import script from "./Sicon.vue?vue&type=script&lang=js&"
export * from "./Sicon.vue?vue&type=script&lang=js&"
import style0 from "./Sicon.vue?vue&type=style&index=0&id=72c95659&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c95659",
  null
  
)

export default component.exports